import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import DynamicTable from "src/components/table";
import { columntype, isValidArray } from "src/helper/publicFunction";
import { GetTrainingWorkshops } from "./actions";
import { GetSubServices } from "../sub_services/actions";

const TrainingWorkshops = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  // sub-service options feed the filter dropdown; selection sets the filter
  const [subServices, setSubServices] = useState([]);
  const [subServiceFilter, setSubServiceFilter] = useState("");

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetTrainingWorkshops({
        rowsPerPage: rowsPerPage,
        page: page,
        subServiceId: subServiceFilter,
        callback: (response) => {
          if (isValidArray(response?.data)) {
            setData(response?.data);
            setTotalData(
              response?.total ?? response?.count ?? response?.data?.length
            );
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
  };

  // the sub-service list only feeds the filter dropdown, so it is fetched once
  useEffect(() => {
    dispatch(
      GetSubServices({
        page: 0,
        rowsPerPage: 100,
        callback: (response) => {
          setSubServices(isValidArray(response?.data) ? response.data : []);
        },
      })
    );
  }, []);

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, subServiceFilter]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "sub_service_name" },
    { type: columntype.filePreview, name: "ba_diploma" },
    { type: columntype.filePreview, name: "ba_transcript" },
    { type: columntype.filePreview, name: "msc_diploma" },
    { type: columntype.filePreview, name: "msc_transcript" },
    { type: columntype.filePreview, name: "cv" },
    { type: columntype.filePreview, name: "cover_letter" },
    { type: columntype.filePreview, name: "passport" },
    { type: columntype.dateAndtime, name: "createdAt" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "sub_service_name",
      numeric: false,
      disablePadding: false,
      label: "Sub Service",
      withSort: false,
    },
    {
      id: "ba_diploma",
      numeric: false,
      disablePadding: false,
      label: "BA Diploma",
      withSort: false,
    },
    {
      id: "ba_transcript",
      numeric: false,
      disablePadding: false,
      label: "BA Transcript",
      withSort: false,
    },
    {
      id: "msc_diploma",
      numeric: false,
      disablePadding: false,
      label: "MSC Diploma",
      withSort: false,
    },
    {
      id: "msc_transcript",
      numeric: false,
      disablePadding: false,
      label: "MSC Transcript",
      withSort: false,
    },
    {
      id: "cv",
      numeric: false,
      disablePadding: false,
      label: "CV",
      withSort: false,
    },
    {
      id: "cover_letter",
      numeric: false,
      disablePadding: false,
      label: "Cover Letter",
      withSort: false,
    },
    {
      id: "passport",
      numeric: false,
      disablePadding: false,
      label: "Passport",
      withSort: false,
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Created At",
      withSort: false,
    },
  ];

  const selectedSubService =
    subServices.find((item) => item?.id === subServiceFilter) || null;

  return (
    <>
      <Box
        sx={{
          width: "98%",
          marginLeft: "17px",
          marginBottom: 2,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "flex-end",
        }}
      >
        <Box sx={{ width: 300 }}>
          <CustomFormLabel sx={{ mt: 0 }}>Sub Service</CustomFormLabel>
          <Autocomplete
            size="small"
            options={subServices}
            value={selectedSubService}
            getOptionLabel={(option) => option?.name ?? ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            onChange={(event, newValue) => {
              setSubServiceFilter(newValue?.id ?? "");
              setPage(0);
            }}
            noOptionsText="No sub services"
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="Select sub service"
              />
            )}
          />
        </Box>
        <Button
          variant="outlined"
          sx={{ height: "40px" }}
          disabled={!subServiceFilter}
          onClick={() => {
            setSubServiceFilter("");
            setPage(0);
          }}
        >
          Clear filter
        </Button>
      </Box>
    <DynamicTable
      handleSearch={(event) => setSearch(event.target.value)}
      onRequestSort={() => {}}
      onPressDelete={() => {}}
      onPressItem={() => {}}
      onPressAnyAction={() => {}}
      onPressAdd={() => {}}
      items={data} // all data
      columns={columns} // type of data
      headCells={headCells} // columns name
      page={page} // number of page from api
      setPage={setPage} // set number of page from api
      selected={selected} // selected items
      setSelected={setSelected} // set selected items
      search={search} // search failed
      rowsPerPage={rowsPerPage} // number show Data
      setRowsPerPage={setRowsPerPage} // set number show data
      Listdropdown={[]} // list action with function
      withOption={false} // for remove action column
      loadingData={loadingData} // when load data from api
      rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
      totalItem={TotalData} // total data without pagination
      loadingEditdatatype={""}
      withAddButton={false}
      withDeleteItem={false}
      withEditItem={false}
      withPagination={true}
      withSearch={false}
    />
    </>
  );
};

export default TrainingWorkshops;
